<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Lifecycle
	import { onMount } from 'svelte';
	//Design system components
	import { Loader, SelectCard, Text } from '@Shelly/shelly-design-system';
	//Stores
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { getPillModes, type PillModeOption } from 'src/helpers/thepill/pill_peripheral_modes';

	export let device: any;
	export let settings: any;
	export const icon: string = '';

	let waitingRorRequest = false;
	let modesLoaded = false;
	let options: PillModeOption[] = [];

	const onChange = (value: string) => {
		sentRequests(value);
	};

	const sentRequests = async (value: string) => {
		if (waitingRorRequest) return;
		waitingRorRequest = true;
		const res: SettingRequest = await gen2Request(device, 'Pill.SetConfig', {
			config: { mode: value },
		});
		if (res.isok) {
			settings.pill.mode = value;
		} else {
			settings.pill.mode = settings.pill.mode;
		}
		onSettingsResponse(res, device);
		waitingRorRequest = false;
	};

	onMount(async () => {
		options = await getPillModes(device, settings);
		modesLoaded = true;
	});
</script>

<div>
	<Text styleType="h2" class="mb-s">
		{$format('subtitle_pill_peripheral_mode', {
			default: 'Select Peripheral Mode',
		})}
	</Text>
	{#if !modesLoaded}
		<div class="d-flex justify-content-center mt-m">
			<Loader />
		</div>
	{:else}
		{#each options as { title, description, disabled, value, icon }}
			<SelectCard
				cardBgColor={$showNewLayout ? 'color-1' : undefined}
				{title}
				descriptiveText={description}
				type="horizontal"
				variant="radio"
				selected={value === settings?.pill?.mode}
				disabled={waitingRorRequest || disabled}
				on:click={() => {
					onChange(value);
				}}
				class="width-full mt-xs"
				{icon}
			></SelectCard>
		{/each}
	{/if}
</div>
